import LearningTimeBreakdown from '@Components/LearningTimeBreakdown/LearningTimeBreakdown'
import { useWidget } from '@eduact/ed-components'
import { FlexLayout } from '@eduact/ed-system'
import { useGetUserProfileQuery } from '@Features/Dashboard/DashboardSlice/Dashboard.slice'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

/** User-scope learning time — the shared breakdown donut in the dashboard widget frame. */
const LearningTimeWidget = () => {
	const [t] = useTranslation('studentDashboard')
	const { setTitle } = useWidget()

	const { data } = useGetUserProfileQuery()
	const userId = Number(data?.data.student.user_id)

	useEffect(() => {
		setTitle(t('learningTime'))
	}, [])

	return (
		<Wrapper flexDirection="row" alignItems="center">
			<LearningTimeBreakdown scope={{ user_id: userId }} skip={!userId} />
		</Wrapper>
	)
}

const Wrapper = styled(FlexLayout)`
	background-color: #fff;
	border-radius: 5px;
	width: 100%;
	height: 250px;
	padding: 0.513rem 0.825rem;
	${({ theme }) => `${theme.mediaQueries.large}{
		padding: 0.963rem 0.556rem;
    	border-radius: 15px;
    	min-height: 18.55rem;
		/* never wider than the flex column it sits in */
		min-width: min(18.938rem, 100%);
	}`}
`
export default LearningTimeWidget
